/**
 * Returns the stored device ID from local storage.
 *
 * @returns {string} - The device ID.
 */
export function getDeviceIDFromLocalStorage() {
    if (!localStorage) {
        return undefined;
    }

    try {
        return JSON.parse(localStorage.getItem('__AMDID'));
    } catch (e) {
        return undefined;
    }
}

/**
 * Sets the device ID to the local storage.
 *
 * @param {string} deviceId - The new device ID.
 * @returns {void}
 */
export function setDeviceIDToLocalStorage(deviceId) {
    if (!localStorage || !deviceId) {
        return;
    }

    localStorage.setItem('__AMDID', JSON.stringify(deviceId));
}
